import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { Button } from "rsuite";

class DevFeisCostEstimateForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("risk_total_value", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        <fieldset disabled={this.props.disabled}>
          <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>
          <label className="col-3 pl-2">
            Annual Inflation Adjustment
            <Field
              className="form-control"
              name={"annual_inflation_adjustment"}
              value={this.props.values.annual_inflation_adjustment || ""}
            />
          </label>
          <label className="col-3 pl-2">
            Capital Cost
            <Field
              className="form-control"
              name={"capital_cost"}
              value={this.props.values.capital_cost || ""}
            />
          </label>
          <label className="col-3 pl-2">
            Capital Cost Breakdown
            <Field
              className="form-control"
              name={"capital_cost_breakdown"}
              value={this.props.values.capital_cost_breakdown || ""}
            />
          </label>
            <label className="col-3 pl-2">
              Estimated Cost Type
              <Field
                className="form-control"
                name={"estimated_cost_type"}
                value={this.props.values.estimated_cost_type || ""}
              />
            </label>
            <label className="col-3 pl-2">
              Financial Cost
              <Field
                className="form-control"
                name={"financial_cost"}
                value={this.props.values.financial_cost || ""}
              />
            </label>
            <label className="col-3 pl-2">
              Financial Cost Breakdown
              <Field
                className="form-control"
                name={"financial_cost_breakdown"}
                value={this.props.values.financial_cost_breakdown || ""}
              />
            </label>
            <label className="col-3 pl-2">
              Other Cost
              <Field
                className="form-control"
                name={"other_cost"}
                value={this.props.values.other_cost || ""}
              />
            </label>
            <label className="col-3 pl-2">
              Other Cost Breakdown
              <Field
                className="form-control"
                name={"other_cost_breakdown"}
                value={this.props.values.other_cost_breakdown || ""}
              />
            </label>
            <label className="col-3 pl-2">
              Risk Assessment
              <Field
                className="form-control"
                name={"risk_assessment"}
                value={this.props.values.risk_assessment || ""}
              />
            </label>
            <label className="col-3 pl-2" style={this.props.errors.risk_total_value && this.props.touched.risk_total_value && {color: "red"}}>
              Risk Total Value
              <Field
                className="form-control"
                name={"risk_total_value"}
                value={this.props.values.risk_total_value || null}
                style={this.props.errors.risk_total_value && this.props.touched.risk_total_value && {color: "red"}}
              />
              {this.props.errors.risk_total_value && this.props.touched.risk_total_value && (
                  <small className={"text-danger"}>{this.props.errors.risk_total_value}</small>
              )}
            </label>
          <label className="col-6 pl-2 d-block">
            Notes
            <Field
                component={"textarea"}
                className="form-control"
                name={"notes"}
                value={this.props.values.notes || ""}
            />
          </label>
        </fieldset>

        {this.props.disabled ? (
            <Button type="button" onClick={this.props.toggleSmallModalHandler}  className="ml-2">
          Cancel
        </Button>) : (
            <div>
              {!this.props.currentDevFeisCostEstimate ? (
                  <Button
                    type="button"
                    color="blue"
                    onClick={() => {
                      validAndHandle(this.props.add, this.props.values);
                    }}
                  >
                    Submit
                  </Button>
              ) : (
                <Button
                  type="button"
                    color="blue"
                  onClick={() => {
                    validAndHandle(this.props.update, this.props.values);
                  }}
                >
                  Update
                </Button>
                  )}
              <Button color="red" type="button" onClick={this.props.handleReset}  className="ml-2">
                Reset
              </Button>
              <Button type="button" onClick={this.props.toggleSmallModalHandler}  className="ml-2">
                Cancel
              </Button>
              </div>
        )}
      </Form>
    );
  }
}

var devFeisCostEstimateSchema = Yup.object().shape({
  risk_total_value: Yup.number().nullable().typeError("Number required"),
});

export default withFormik({
  validationSchema: devFeisCostEstimateSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentDevFeisCostEstimate }) {
    return {
      ...currentDevFeisCostEstimate
    };
  }
})(DevFeisCostEstimateForm);
